import { Controller } from "@hotwired/stimulus";
import * as Turbo from "@hotwired/turbo";
import { fetchApi } from "../../../helpers/reactQueryApi";
import bridge from "../../../turbo/bridge";

// Connects to data-controller="administration--profile-change-requests--send-batch-actions"
export default class extends Controller {
  connect() {
    // Listen for modal show event to prepare data
    const modal = document.getElementById("batchRejectModal");
    if (modal) {
      modal.addEventListener("show.bs.modal", () => {
        this.#prepareRejectModal();
      });
    }

    // Intercept the reject form submit
    const rejectForm = document.getElementById("batch-reject-form");
    if (rejectForm) {
      rejectForm.addEventListener("submit", (event) => {
        event.preventDefault();
        this.#submitRejectForm(event.target);
      });
    }
  }

  approveRequests() {
    const request_ids = this.#getSelectedRequestIds();

    bridge.confirm(
      I18n.t(
        "js.administration.profile_change_requests.batch_approve.confirm",
        {
          count: request_ids.length,
        },
      ),
      () => {
        fetchApi("/batch_profile_change_requests/approve", {
          method: "POST",
          body: {
            profile_change_request_ids: request_ids,
          },
        })
          .then(() => this.#submitSuccess("approve", request_ids.length))
          .catch(this.#submitFailure);
      },
    );
  }

  rejectRequests(event) {
    const request_ids = this.#getSelectedRequestIds();

    if (request_ids.length === 0) {
      event.preventDefault();
      return;
    }
  }

  #prepareRejectModal() {
    const request_ids = this.#getSelectedRequestIds();

    // Update modal title with count
    const titleElement = document.getElementById("batch-reject-title");
    const titleTemplate = titleElement.dataset.titleTemplate;
    titleElement.textContent = titleTemplate.replace(
      "%{count}",
      String(request_ids.length),
    );

    // Clear any existing hidden fields
    const form = document.getElementById("batch-reject-form");
    const existingFields = form.querySelectorAll(
      'input[name="profile_change_request_ids[]"]',
    );
    existingFields.forEach((field) => field.remove());

    // Add hidden fields for each selected request ID
    request_ids.forEach((id) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "profile_change_request_ids[]";
      input.value = id;
      form.appendChild(input);
    });

    // Clear the rejection reason textarea
    const textarea = form.querySelector('textarea[name="rejection_reason"]');
    if (textarea) {
      textarea.value = "";
    }
  }

  #submitRejectForm(form) {
    const formData = new FormData(form);
    const request_ids = formData.getAll("profile_change_request_ids[]");
    const rejection_reason = formData.get("rejection_reason");

    if (!rejection_reason || rejection_reason.trim() === "") {
      toastr.error(
        I18n.t("administration.profile_change_requests.reject.reason_required"),
      );
      return;
    }

    fetchApi("/batch_profile_change_requests/reject", {
      method: "POST",
      body: {
        profile_change_request_ids: request_ids,
        rejection_reason: rejection_reason,
      },
    })
      .then(() => {
        // Close the modal by clicking the close button
        const closeButton = document.querySelector(
          '#batchRejectModal [data-bs-dismiss="modal"]',
        );
        closeButton?.click();

        this.#submitSuccess("reject", request_ids.length);
      })
      .catch(this.#submitFailure);
  }

  #getSelectedRequestIds() {
    const selectedCheckboxes = this.element.querySelectorAll(
      'input[name="profile_change_request_select"]:checked',
    );
    return Array.from(selectedCheckboxes).map(
      (checkbox) => checkbox.id.split("-")[1],
    );
  }

  #submitSuccess(action, count) {
    toastr.success(
      I18n.t(
        `js.administration.profile_change_requests.batch_${action}.success_flash`,
        { count },
      ),
    );

    const url = this.getUrlForPage();

    Turbo.visit(url.toString(), {
      action: "replace",
    });
  }

  #submitFailure() {
    toastr.error(
      I18n.t("js.administration.profile_change_requests.batch_error"),
    );
  }

  getUrlForPage() {
    const pageField = document.querySelector("input[name='page']");
    const page = pageField ? pageField.value : "1";

    const url = new URL(location.pathname, window.location.origin);
    url.searchParams.set("page", page);

    return url;
  }
}
